module.exports = __webpack_public_path__ + "img/avatar.190773f1.svg";